module.exports = __webpack_public_path__ + "media/application/images/ui/badge-trusted-c3c59c9a4e95b01a1fcf0c0a3a35f2df.png";